var render, staticRenderFns
import script from "./MonthIncomeChart.vue?vue&type=script&lang=js&"
export * from "./MonthIncomeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a52b2c",
  null
  
)

export default component.exports